import { render, staticRenderFns } from "./Catalog.vue?vue&type=template&id=7a464122"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a464122')) {
      api.createRecord('7a464122', component.options)
    } else {
      api.reload('7a464122', component.options)
    }
    module.hot.accept("./Catalog.vue?vue&type=template&id=7a464122", function () {
      api.rerender('7a464122', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrintSuite/Catalog.vue"
export default component.exports